// extracted by mini-css-extract-plugin
export default {"hamburger":"hamburger_hamburger__+l8Gz","navigation":"hamburger_navigation__u1L4G","isOpen":"hamburger_isOpen__lQzYj"};